import { Component, ElementRef, ViewChild } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ApproveModel } from '../approve/approve.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ApproveService } from '../approve/approve.service';

@Component({
  selector: 'app-approveadmin',
  templateUrl: './approveadmin.component.html',
  styleUrls: ['./approveadmin.component.scss']
})
export class ApproveadminComponent {
  public tableData: Array<ApproveModel> = [];
  public isLoaded: boolean = true;
  public validationCode: string = '';
  public errorMessage: string = '';
  public isAprove: boolean = false;
  public selectedIds: string[] = [];

  /**
  *
  */
  constructor(public approveService: ApproveService,
              public authService : AuthService,
              private toastr: ToastrService,
              private modalService: NgbModal)
  {
    this.getPendingWithdraw();
  }

  @ViewChild('modalConfirmEnable') modalConfirmEnable : ElementRef | any;

  getPendingWithdraw()
  {
    this.isLoaded = false;

    this.approveService.getPendingWithdraw().subscribe((value)=>
    {
      this.tableData = value;
    });

    this.isLoaded = true;
  }

  approve(isAproved: boolean)
  {
    this.isLoaded = false;
    if(this.tableData.filter(t => t.selected).length === 0){
      this.toastr.error('Selecione um item para prosseguir com a operação!','Erro',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      this.isLoaded = true;
      return;
    }

    this.isAprove = isAproved;
    this.selectedIds = this.tableData.filter(t => t.selected).map(itm => itm.id);
    this.isLoaded = true;
    this.modalService.open(this.modalConfirmEnable, {backdrop: "static", keyboard: true, centered: true, size: 'sm'});
  }

  async isValidTotp()
  {
    let isValid: boolean = false;
    await this.authService.validateTotpCode(this.validationCode).then(
      value => {
        isValid = value.isValid;
      }
    );
    return isValid;
  }

  async executeAprove()
  {
    if(this.selectedIds.length == 0)
    {
      this.modalService.dismissAll();
      this.toastr.error('Erro ao selecionar pagamentos!','Erro!',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
    }

    await lastValueFrom(this.approveService.approveOrNotWithdraw(this.selectedIds, this.isAprove, this.validationCode)).then();

    this.modalService.dismissAll();
    this.toastr.success('Operação realizada com sucesso!','Sucesso!',{
      timeOut: 3000,
      positionClass: 'toast-top-right',
    });
  }

  reload() {
    this.getPendingWithdraw();
  }
}
